export default __webpack_public_path__ + "static/media/bench-about.2e6ca588.png";